import React from "react";
import {
  Calendar,
  Callout,
  Checkbox,
  DayOfWeek,
  DefaultButton,
  // DetailsHeader,
  DetailsList,
  DetailsListLayoutMode,
  DetailsRow,
  // DetailsRowCheck,
  DirectionalHint,
  // Dropdown,
  Fabric,
  FocusTrapZone,
  IBasePickerSuggestionsProps,
  IColumn,
  IDetailsListProps,
  // IDetailsRowStyleProps,
  IDetailsRowStyles,
  IDropdownOption,
  ITag,
  // MarqueeSelection,
  PrimaryButton,
  // Selection,
  SelectionMode,
  Stack,
  TagPicker,
  Text,
} from "office-ui-fabric-react";
import { useParams } from "react-router";
import { Loading } from "../../services/Loading";
import { ConfirmDialogContext } from "../common/ConfirmDialogProvider";
import {
  childrenGap,
  childrenGap8,
  DayPickerStrings,
  MEETINGS_LEGEND_DICT,
  MEETINGS_LOCATION_DICT,
  MEETINGS_OWNER_DICT,
  MEETINGS_STATUS_DICT,
  // MEETINGS_STATUS_DROPDOWN,
} from "../common/Constants";
import NoDataTile from "../common/NoDataTile";
import { ToastContext } from "../common/ToastProvider";
import ManagePmDialog from "../customers/previous-meetings/ManagePmDialog";
import { IAdmin, ICustomers, IPreviousMeeting } from "../../vm";
import { deletePreviousMeeting } from "../../services/customers/CustomerService";
import { mdiDotsVertical } from "@mdi/js";
import moment from "moment";
import Icon from "@mdi/react";
import { getMomStatusDetails, getMomStatusDetailsExcel } from "../../services/dashboard/DashboardService";
import PageTitle from "../common/PageTitle";
import { ReactComponent as PMIcon } from "../../images/meetings-icon.svg";
import { parseJwt } from "../../services/UtilService";
import { getAllAdmins, getCemAssignToACustomer } from "../../services/datacenter/DataCenterManagerService";
// import { calculateAging } from "../customers/previous-meetings/PreviousMeeting";
import ManagePmSendEmailDialog from "../customers/previous-meetings/ManagePmSendEmailDialog";
import TotalNumbers from "../common/TotalNumbers";

export interface MomStatusDetailsProps { }
let calendarButtonElement: HTMLElement;

const MomStatusDetails: React.FC<MomStatusDetailsProps> = () => {
  // custom hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const tokenData = parseJwt();

  const queryParams = new URLSearchParams(window.location.search);

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    previousMeetings: [],
    customers: [],
    searchObj: {
      startDate: queryParams.get("startDate")
        ? queryParams.get("startDate")
        : moment().startOf("month").toDate(),
      endDate: queryParams.get("endDate")
        ? queryParams.get("endDate")
        : moment().endOf("month").toDate(),
      status: queryParams.get("status") ? [queryParams.get("status")] : [],
      sendCustomerDetails: true,
      ignoreDateRange: queryParams.get("ignoreDateRange") ? queryParams.get("ignoreDateRange") === 'true' ? true : false : false,
      cemIds: queryParams.get("cemId") ? [queryParams.get("cemId")] : [],
      customerIds: [],
      sortBy: "meetingDate",
      sortOrder: "desc"
    },
    manageAcDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
      customerName: undefined
    },
    manageActionsCallout: {
      isOpen: false,
      index: undefined,
      element: undefined,
      data: undefined,
    },
    showCallender: false,
    status: queryParams.get("status") ? queryParams.get("status") : "",
    userListByCustomerId: {},
    userDict: {},
  } as {
    isLoading: boolean;
    previousMeetings: IPreviousMeeting[];
    customers: ITag[];
    searchObj: {
      startDate: string;
      endDate: string;
      status: string[];
      sendCustomerDetails: boolean;
      ignoreDateRange: boolean;
      cemIds: string[];
      customerIds: string[];
      sortBy: "meetingDate" | "targetDate" | "completionDate" | "aging" | "startDate",
      sortOrder: "asc" | "desc"
    };
    manageAcDialog: {
      isOpen: boolean;
      index?: number;
      data?: IPreviousMeeting;
      customerName?: string
    };
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      index?: number;
      data?: IPreviousMeeting;
    };
    showCallender: boolean;
    status: string;
    userListByCustomerId: { [key: string]: IDropdownOption[] };
    userDict: { [key: string]: IAdmin };
  });
  const [cemUserList, setCemUserList] = React.useState([] as ITag[]);
  // const [selectedMeetingIds, setSelectedMeetingIds] = React.useState([] as string[]);
  // const [isSendEmailDialogOpen, setIsSendEmailDialogOpen] = React.useState(false as boolean);

  React.useEffect(() => {
    const asyncFunc = async () => {
      setState({ ...state, isLoading: true });
      // await getAllCemUsers();
      await getAllPreviousMeeting();
    };
    asyncFunc();
  }, []);

  const getAllPreviousMeeting = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState) {
      localState = { ...paramState };
      setState({ ...localState, isLoading: true });
    }

    // // checking all is selected or not, if selected then send empty array for status
    // let isShowAll = localState.searchObj.status.includes('all');
    // if (isShowAll) localState.searchObj.status = [];

    let result = await getMomStatusDetails(localState.searchObj);

    // // if all selected then again reassign it
    // if (isShowAll) localState.searchObj.status = ['all'];

    if (result?.success) {
      let customers = [...state.customers];
      let customerIds: string[] = [];
      result.data.customers.forEach((d) => {
        customerIds.push(d._id as string);
        const found = customers.find((dd) => dd.key === d._id);
        if (!found) customers.push({ key: d._id as string, name: d.name });
      });
      let obj = {
        ...localState,
        previousMeetings: result.data.data,
        customers
      };
      setState(obj);
      // setSelectedMeetingIds([]);
      // if (customerIds.length > 0) {
      await getAllCemUsers(obj);
      // await getCemUsers(obj, customerIds);
      // } else {
      //   setState({
      //     ...obj, isLoading: false,
      //   });
      // }
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result?.message || "Error while getting customer meetings",
        "error"
      );
    }
  };

  // const getCemUsers = async (paramState: any, customerIds: string[]) => {
  //   let result = await getCemAssignToACustomer(customerIds);
  //   if (result?.success) {
  //     const dict: any = {};
  //     const listArrayDict = Object.keys(result.data).reduce((acc: any, customerId: string) => {
  //       let data = result.data[customerId] || [];
  //       acc[customerId] = data.map((d) => {
  //         dict[d._id as string] = d;
  //         return { key: d._id, text: d.name };
  //       })
  //       return acc;
  //     }, {});
  //     setState({
  //       ...state,
  //       ...paramState,
  //       userDict: dict,
  //       userListByCustomerId: listArrayDict,
  //       isLoading: false,
  //     });
  //   } else {
  //     setState({ ...paramState, isLoading: false });
  //     showToast(
  //       result?.message || "Error while getting cem users",
  //       "error"
  //     );
  //   }
  // };

  const getAllCemUsers = async (paramState: typeof state) => {
    let result = await getAllAdmins({ role: 2, sendEnabledItems: true });
    let dict: any = {};
    if (result && result.success) {
      let list: ITag[] = result.data.map((d: IAdmin) => {
        dict[d._id as string] = d;
        return { key: d._id, name: d.name };
      });
      setCemUserList(list);
    } else {
      showToast(result?.message || "Error while getting Cem users", "error");
    }
    // setting state
    setState({ ...paramState, userDict: dict, isLoading: false });
  };

  // const handleDialogOpen = (isOpen: boolean, index?: number) => {
  //   let previousMeetings: any = undefined;
  //   let customerName = undefined;
  //   if (index !== undefined) {
  //     previousMeetings = { ...state.previousMeetings[index] };
  //     customerName = state.customers.find((d) => d.key === previousMeetings?.customerId)?.name;
  //   }
  //   setState({
  //     ...state,
  //     manageAcDialog: {
  //       isOpen,
  //       index,
  //       data: previousMeetings,
  //       customerName,
  //     },
  //   });
  // };

  // const handleDialogClose = async (data: IPreviousMeeting) => {
  //   // let previousMeetings = [...state.previousMeetings];
  //   if (data) {
  //     if (state.manageAcDialog.index !== undefined) {
  //       // let previousMeetings = [...state.previousMeetings];
  //       // previousMeetings[state.manageAcDialog.index] = data;
  //       // setState({
  //       //   ...state,
  //       //   manageAcDialog: {
  //       //     isOpen: false,
  //       //     index: undefined,
  //       //     data: undefined,
  //       //   },
  //       //   previousMeetings,
  //       // });
  //       showToast("Customer Meeting updated successfully", "success");
  //     } else {
  //       // previousMeetings.unshift(data);
  //       showToast("Customer Meeting added successfully", "success");
  //     }
  //     await getAllPreviousMeeting({
  //       ...state,
  //       manageAcDialog: {
  //         isOpen: false,
  //         index: undefined,
  //         data: undefined,
  //       }
  //     });
  //   } else {
  //     setState({
  //       ...state,
  //       manageAcDialog: {
  //         isOpen: false,
  //         index: undefined,
  //         data: undefined,
  //       },
  //     });
  //   }
  //   // setState({
  //   //   ...state,
  //   //   manageAcDialog: {
  //   //     isOpen: false,
  //   //     index: undefined,
  //   //     data: undefined,
  //   //   },
  //   //   previousMeetings,
  //   // });
  // };

  // const handleEmailDialogOpenClose = (isOpen: boolean, isSendEmail?: boolean) => {
  //   setIsSendEmailDialogOpen(isOpen);
  //   if (isSendEmail) setSelectedMeetingIds([]);
  // }

  // const handleLoading = () => {
  //   setState({
  //     ...state,
  //     isLoading: !state.isLoading,
  //   });
  // };

  // const deletePm = async (item: IPreviousMeeting, index: number) => {
  //   showConfirmDialog(
  //     "Are You Sure",
  //     "Do you want to delete customer meeting",
  //     async () => {
  //       setState({
  //         ...state,
  //         isLoading: true,
  //         manageActionsCallout: {
  //           isOpen: false,
  //           index: undefined,
  //           element: undefined,
  //           data: undefined,
  //         },
  //       });
  //       let result = await deletePreviousMeeting(item);
  //       if (result?.success) {
  //         showToast("Customer Meeting deleted successfully", "success");
  //         let previousMeetings = [...state.previousMeetings];
  //         previousMeetings.splice(index, 1);
  //         setState({
  //           ...state,
  //           previousMeetings,
  //           isLoading: false,
  //           manageActionsCallout: {
  //             isOpen: false,
  //             index: undefined,
  //             element: undefined,
  //             data: undefined,
  //           },
  //         });
  //       } else {
  //         setState({
  //           ...state,
  //           isLoading: false,
  //           manageActionsCallout: {
  //             isOpen: false,
  //             index: undefined,
  //             element: undefined,
  //             data: undefined,
  //           },
  //         });
  //         showToast(
  //           result.message || "Error while deleting customer meeting",
  //           "error"
  //         );
  //       }
  //     }
  //   );
  // };

  const _renderItemColumn = (item: any, index: number, column: IColumn) => {
    switch (column.key) {
      // case "actions":
      //   return (
      //     (tokenData.isAdmin && tokenData.role === 0) || item.userId === tokenData._id ? (
      //       <span
      //         onClick={(ele) => handleCallOutOpenClose(true, ele, index, item)}
      //       >
      //         <Icon
      //           path={mdiDotsVertical}
      //           size={0.9}
      //           className="pointer"
      //           color={BRAND_SECONDARY}
      //         />
      //       </span>
      //     ) : (
      //       <></>
      //     )
      //     // <Stack horizontal>
      //     //   <TooltipHost
      //     //     content={`Edit Previous Meeting`}
      //     //     id={`editEm`}
      //     //     calloutProps={{ gapSpace: 0 }}
      //     //     styles={{ root: { display: "inline-block" } }}
      //     //   >
      //     //     <span onClick={() => handleDialogOpen(true, index)}>
      //     //       <Icon
      //     //         path={mdiPencilOutline}
      //     //         size={0.8}
      //     //         className="pointer"
      //     //         color={THEME.palette.neutralPrimary}
      //     //       />
      //     //     </span>
      //     //   </TooltipHost>
      //     //   &nbsp;&nbsp;
      //     //   <TooltipHost
      //     //     content={`Delete Previous Meeting`}
      //     //     id={`deleteEm`}
      //     //     calloutProps={{ gapSpace: 0 }}
      //     //     styles={{ root: { display: "inline-block" } }}
      //     //   >
      //     //     <span onClick={() => deleteSd(item, index)}>
      //     //       <Icon
      //     //         path={mdiTrashCanOutline}
      //     //         size={0.8}
      //     //         className="pointer"
      //     //         color={THEME.palette.themePrimary}
      //     //       />
      //     //     </span>
      //     //   </TooltipHost>
      //     // </Stack>
      //   );
      case "sttParticipant":
        return <span>{`${item.sttParticipantName} (${item.sttParticipantEmail})`}</span>;
      case "customerParticipant":
        return <span>{`${item.customerParticipantName} (${item.customerParticipantEmail})`}</span>;
      case "showInPpt":
        return <span>{item.status === "closed" ? item.showInPpt ? "Yes" : "No" : "NA"}</span>;
      case "aging":
        return <span>{item.aging == null ? 'NA' : item.aging}</span>;
      // return <span>{calculateAging(item)}</span>;
      case "status":
        return <span>{MEETINGS_STATUS_DICT[item.status]}</span>;
      case "meetingLocation":
        return <span>{MEETINGS_LOCATION_DICT[item.meetingLocation]}</span>;
      case "owner":
        return <span>{MEETINGS_OWNER_DICT[item.owner] || 'NA'}</span>;
      case "legendId":
        return <span>{MEETINGS_LEGEND_DICT[item.legendId] || 'NA'}</span>;
      case "targetDate":
        return (
          <span>
            {item.targetDate
              ? moment(item.targetDate).format("DD/MM/YYYY")
              : "NA"}
          </span>
        );
      case "completionDate":
        return <span>{item.completionDate ? moment(item.completionDate).format("DD/MM/YYYY") : "NA"}</span>;
      case "meetingDate":
        return <span>{item.meetingDate ? moment(item.meetingDate).format("DD/MM/YYYY HH:mm A") : "NA"}</span>;
      case "startDate":
        return <span>{item.startDate ? moment(item.startDate).format("DD/MM/YYYY") : "NA"}</span>;
      case "customerId":
        return (
          <Text style={{ fontWeight: 600 }}>
            {state.customers?.find((c) => c.key === item.customerId)?.name}
          </Text>
        );
      // case "legendId":
      //   return (
      //     <Text style={{ fontWeight: 600 }}>
      //       {item[column.fieldName as any]}
      //     </Text>
      //   );
      case "userId":
        return <span>{state.userDict[item.userId]?.name || "NA"}</span>;
      // case "checkbox":
      //   return (
      //     (tokenData.isAdmin && tokenData.role === 0) || item.userId === tokenData._id ?
      //       <Checkbox
      //         checked={selectedMeetingIds.includes(item._id)}
      //         onChange={(e, v) => {
      //           let meetingIds = [...selectedMeetingIds];
      //           const index = meetingIds.findIndex((d) => d === item._id);
      //           if (index !== -1) {
      //             meetingIds.splice(index, 1);
      //           } else {
      //             meetingIds.push(item._id);
      //           }
      //           setSelectedMeetingIds(meetingIds);
      //         }}
      //       /> : <></>
      //   );
      default:
        return <span>{column.fieldName ? item[column.fieldName] || "NA" : "NA"}</span>;
    }
  };

  const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
      if (props.itemIndex % 2 !== 0) {
        customStyles.root = { backgroundColor: "#F3F3F3" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
      // return <DetailsRow {...props} styles={customStyles} onRenderCheck={(rowCheckProps) => <DetailsRowCheck {...rowCheckProps} canSelect={tokenData.role === 0 || props.item.userId === tokenData._id ? true : false} />} checkboxVisibility={1} />;
    }
    return null;
  };

  // const _onRenderDetailsHeader: IDetailsListProps["onRenderDetailsHeader"] = (props) => {
  //   if (props) {
  //     console.log(props);
  //     return <DetailsHeader {...props} onRenderDetailsCheckbox={(checkboxProps) => <div />} className="checkbox-pointer-event-none" />;
  //   }
  //   return null;
  // };

  // const _selection = new Selection({
  //   onSelectionChanged: () => {
  //     const selectedItems = _selection.getSelection();
  //     const ids = selectedItems.map((d: any) => d._id);
  //     console.log(ids);
  //     setSelectedMeetingIds(ids);
  //   },
  // });

  const onColumnClick = async (ev: React.MouseEvent<HTMLElement, MouseEvent>, column: IColumn) => {
    let searchObj = { ...state.searchObj };
    if (searchObj.sortBy === column.key) {
      searchObj.sortOrder = searchObj.sortOrder === "desc" ? "asc" : "desc";
    } else {
      searchObj.sortBy = column.key as any;
      searchObj.sortOrder = "asc";
    }
    await getAllPreviousMeeting({ ...state, searchObj });
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    index?: number,
    data?: IPreviousMeeting
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        index,
        data,
      },
    });
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const statusPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No status found",
  };

  const cemPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No cem found",
  };

  const customerPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No customer found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allStatusTag = Object.keys(MEETINGS_STATUS_DICT).map((d) => ({ key: d, name: MEETINGS_STATUS_DICT[d] }));

    return filterText
      ? allStatusTag.filter(
        (tag) =>
          tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
          !listContainsTagList(tag, tagList)
      )
      : [];
  };

  const filterSuggestedTagsForCem = (filterText: string, tagList: ITag[]): ITag[] => {
    let allCemTags = [...cemUserList];

    return filterText
      ? allCemTags.filter(
        (tag) =>
          tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
          !listContainsTagList(tag, tagList)
      )
      : [];
  };

  const filterSuggestedTagsForCustomer = (filterText: string, tagList: ITag[]): ITag[] => {
    let allCustomerTags = [...state.customers];

    return filterText
      ? allCustomerTags.filter(
        (tag) =>
          tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
          !listContainsTagList(tag, tagList)
      )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allStatusTag = Object.keys(MEETINGS_STATUS_DICT).map((d) => ({ key: d, name: MEETINGS_STATUS_DICT[d] }));

    return removeDuplicates(allStatusTag, selectedItems);
  };

  const showAllTagsForCem = (selectedItems?: ITag[] | undefined) => {
    let allCemTags = [...cemUserList];

    return removeDuplicates(allCemTags, selectedItems);
  };

  const showAllTagsForCustomer = (selectedItems?: ITag[] | undefined) => {
    let allCustomerTags = state.customers;

    return removeDuplicates(allCustomerTags, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  const downloadReport = async () => {
    const result = await getMomStatusDetailsExcel(state.searchObj);
    let xlsx = await result.blob();
    const xlFile = await new Blob([xlsx], {
      type: "application/vnd.openxmlformats",
    });
    const xlFileURL = await URL.createObjectURL(xlFile);
    var a: any = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display:none";
    a.href = xlFileURL;
    a.download = `MOR Customer Meetings List.xlsx`;
    a.click();
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack tokens={childrenGap}>
        <Stack.Item>
          <PageTitle
            icon={PMIcon}
            title="Customer Meetings"
            description="List of all customer meetings by status"
          />
        </Stack.Item>
        <Stack.Item>
          <Stack tokens={childrenGap} horizontal horizontalAlign="space-between">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap} verticalAlign="center">
                <Stack.Item>
                  <div
                    ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}
                  >
                    <DefaultButton
                      text={
                        !state.searchObj.startDate
                          ? "Select a month"
                          : moment(state.searchObj.startDate).format("MMM-YYYY")
                      }
                      onClick={() => setState({ ...state, showCallender: true })}
                      className="month-picker-btn"
                      disabled={state.searchObj.ignoreDateRange}
                    />
                  </div>
                  {state.showCallender && (
                    <Callout
                      isBeakVisible={false}
                      // className="ms-DatePicker-callout"
                      gapSpace={0}
                      doNotLayer={false}
                      target={calendarButtonElement}
                      directionalHint={DirectionalHint.bottomLeftEdge}
                      onDismiss={() => closeCallender()}
                      setInitialFocus
                    >
                      <FocusTrapZone
                        firstFocusableSelector="ms-DatePicker-day--today"
                        isClickableOutsideFocusTrap
                      >
                        <Calendar
                          // eslint-disable-next-line react/jsx-no-bind
                          onSelectDate={async (date: Date | null | undefined) => {
                            // setState()
                            let obj = {
                              ...state,
                              searchObj: {
                                ...state.searchObj,
                                startDate: moment(date)
                                  .startOf("month")
                                  .format("YYYY-MM-DD"),
                                endDate: moment(date)
                                  .endOf("month")
                                  .format("YYYY-MM-DD"),
                              },
                              showCallender: false,
                            };
                            await getAllPreviousMeeting(obj);
                          }}
                          onDismiss={() => closeCallender()}
                          isMonthPickerVisible={true}
                          value={new Date(state.searchObj.startDate)}
                          firstDayOfWeek={DayOfWeek.Sunday}
                          strings={DayPickerStrings}
                          isDayPickerVisible={false}
                          highlightCurrentMonth={false}
                          highlightSelectedMonth={true}
                          showMonthPickerAsOverlay={false}
                          showGoToToday={false}
                          maxDate={new Date(Date.now())}
                        />
                      </FocusTrapZone>
                    </Callout>
                  )}
                </Stack.Item>
                <Stack.Item>
                  <TagPicker
                    selectedItems={state.searchObj.status.map((d) => ({ key: d, name: MEETINGS_STATUS_DICT[d] }))}
                    removeButtonAriaLabel="Remove"
                    onResolveSuggestions={filterSuggestedTags as any}
                    pickerSuggestionsProps={statusPickerSuggestionsProps}
                    onEmptyResolveSuggestions={showAllTags}
                    inputProps={{
                      placeholder: "Select a status",
                    }}
                    styles={{ root: { minWidth: "200px" } }}
                    onChange={async (items: any) => {
                      let status: string[] = [];
                      items.forEach((i: any) => {
                        status.push(i.key);
                      });
                      let obj = {
                        ...state,
                        searchObj: {
                          ...state.searchObj,
                          status
                        },
                      };
                      await getAllPreviousMeeting(obj as any);
                    }}
                  />
                  {/* <Dropdown
                options={MEETINGS_STATUS_DROPDOWN}
                selectedKey={state.status}
                styles={{ dropdown: { width: 200 } }}
                onChange={async (e, v: IDropdownOption | undefined) => {
                  if (v) {
                    let status: string[] = [];
                    status.push(v.key as string);
                    let obj = {
                      ...state,
                      status: v.key as string,
                      searchObj: {
                        ...state.searchObj,
                        status,
                      },
                    };
                    // setState();
                    await getAllPreviousMeeting(obj as any);
                  }
                }}
              /> */}
                </Stack.Item>
                <Stack.Item>
                  <TagPicker
                    selectedItems={state.customers.filter((d) => state.searchObj.customerIds.includes(d.key as string))}
                    removeButtonAriaLabel="Remove"
                    onResolveSuggestions={filterSuggestedTagsForCustomer as any}
                    pickerSuggestionsProps={customerPickerSuggestionsProps}
                    onEmptyResolveSuggestions={showAllTagsForCustomer}
                    inputProps={{
                      placeholder: "Select a customer",
                    }}
                    styles={{ root: { minWidth: "200px" } }}
                    onChange={async (items: any) => {
                      let customerIds: string[] = [];
                      items.forEach((i: any) => {
                        customerIds.push(i.key);
                      });
                      let obj = {
                        ...state,
                        searchObj: {
                          ...state.searchObj,
                          customerIds
                        },
                      };
                      await getAllPreviousMeeting(obj as any);
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <TagPicker
                    selectedItems={cemUserList.filter((d) => state.searchObj.cemIds.includes(d.key as string))}
                    removeButtonAriaLabel="Remove"
                    onResolveSuggestions={filterSuggestedTagsForCem as any}
                    pickerSuggestionsProps={cemPickerSuggestionsProps}
                    onEmptyResolveSuggestions={showAllTagsForCem}
                    inputProps={{
                      placeholder: "Select a cem",
                    }}
                    styles={{ root: { minWidth: "200px" } }}
                    onChange={async (items: any) => {
                      let cemIds: string[] = [];
                      items.forEach((i: any) => {
                        cemIds.push(i.key);
                      });
                      let obj = {
                        ...state,
                        searchObj: {
                          ...state.searchObj,
                          cemIds
                        },
                      };
                      await getAllPreviousMeeting(obj as any);
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <Checkbox
                    label="Show All data irrespective of date"
                    checked={state.searchObj.ignoreDateRange}
                    onChange={async (e, v) => {
                      let obj = {
                        ...state,
                        searchObj: {
                          ...state.searchObj,
                          ignoreDateRange: v
                        },
                      };
                      await getAllPreviousMeeting(obj as any);
                    }}
                  />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* it was here before */}
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <Stack.Item>
              <TotalNumbers value={state.previousMeetings.length} />
            </Stack.Item>
            <Stack.Item>
              <Stack tokens={childrenGap} horizontal wrap horizontalAlign="end">
                {/* {tokenData.isAdmin && [0, 2].includes(tokenData.role) && selectedMeetingIds.length > 0 && (
                  <Stack.Item>
                    <PrimaryButton text="Send Email" onClick={() => handleEmailDialogOpenClose(true)} />
                  </Stack.Item>
                )} */}
                <Stack.Item>
                  <PrimaryButton text="Export" onClick={downloadReport} disabled={state.previousMeetings.length === 0} />
                </Stack.Item>
                {/* {tokenData.isAdmin && [0, 2].includes(tokenData.role) && (
                  <Stack.Item>
                    <PrimaryButton
                      text="Add Customer Meeting"
                      onClick={() => handleDialogOpen(true)}
                      className="borderless-btn bg-white"
                    />
                  </Stack.Item>
                )} */}
              </Stack>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          {state.previousMeetings && state.previousMeetings.length > 0 ? (
            // <MarqueeSelection selection={_selection}>
            <Fabric>
              <DetailsList
                items={state.previousMeetings}
                columns={[
                  {
                    key: "customerId",
                    name: "Customer",
                    fieldName: "customerId",
                    minWidth: 250,
                    maxWidth: 370,
                    isResizable: true,
                  },
                  {
                    key: "meetingDate",
                    name: "Meeting Date",
                    fieldName: "meetingDate",
                    minWidth: 160,
                    maxWidth: 210,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "meetingDate",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "sttParticipant",
                    name: "STTGDC Participant (Name, Email)",
                    fieldName: "sttParticipant",
                    minWidth: 250,
                    maxWidth: 400,
                    isResizable: true,
                  },
                  {
                    key: "customerParticipant",
                    name: "Customer Participant (Name, Email)",
                    fieldName: "customerParticipant",
                    minWidth: 250,
                    maxWidth: 400,
                    isResizable: true,
                  },
                  {
                    key: "meetingLocation",
                    name: "Meeting Location",
                    fieldName: "meetingLocation",
                    minWidth: 150,
                    maxWidth: 200,
                    isResizable: true,
                  },
                  {
                    key: "agenda",
                    name: "Agenda",
                    fieldName: "agenda",
                    minWidth: 250,
                    maxWidth: 500,
                    isResizable: true,
                  },
                  {
                    key: "legendId",
                    name: "Legend Id",
                    fieldName: "legendId",
                    minWidth: 120,
                    maxWidth: 150,
                    isResizable: true,
                  },
                  {
                    key: "discussion",
                    // name: "Discussion / Action Items",
                    name: "Discussion",
                    fieldName: "discussion",
                    minWidth: 250,
                    maxWidth: 500,
                    isResizable: true,
                  },
                  {
                    key: "owner",
                    name: "Owner",
                    fieldName: "owner",
                    minWidth: 100,
                    maxWidth: 130,
                    isResizable: true,
                  },
                  {
                    key: "ownerName",
                    name: "Owner Name",
                    fieldName: "ownerName",
                    minWidth: 150,
                    maxWidth: 200,
                    isResizable: true,
                  },
                  {
                    key: "ownerEmail",
                    name: "Owner Email",
                    fieldName: "ownerEmail",
                    minWidth: 150,
                    maxWidth: 200,
                    isResizable: true,
                  },
                  {
                    key: "startDate",
                    name: "Start Date",
                    fieldName: "startDate",
                    minWidth: 100,
                    maxWidth: 150,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "startDate",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "targetDate",
                    name: "Target Date",
                    fieldName: "targetDate",
                    minWidth: 120,
                    maxWidth: 170,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "targetDate",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "completionDate",
                    name: "Close Date",
                    // name: "Actual Date",
                    // name: "Completion Date",
                    fieldName: "completionDate",
                    minWidth: 130,
                    maxWidth: 180,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "completionDate",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "status",
                    name: "Status",
                    fieldName: "status",
                    minWidth: 135,
                    maxWidth: 200,
                    isResizable: true,
                  },
                  {
                    key: "remarks",
                    // name: "Latest Updates",
                    name: "Remarks",
                    fieldName: "remarks",
                    minWidth: 200,
                    maxWidth: 300,
                    isResizable: true,
                  },
                  {
                    key: "aging",
                    name: "Aging (in Days)",
                    fieldName: "aging",
                    minWidth: 140,
                    maxWidth: 190,
                    isResizable: true,
                    isSorted: state.searchObj.sortBy === "aging",
                    isSortedDescending: state.searchObj.sortOrder === "desc",
                    onColumnClick: onColumnClick
                  },
                  {
                    key: "showInPpt",
                    name: "Show In PPT",
                    fieldName: "showInPpt",
                    minWidth: 120,
                    maxWidth: 170,
                    isResizable: true,
                  },
                  {
                    key: "userId",
                    name: "Added By",
                    fieldName: "userId",
                    minWidth: 170,
                    maxWidth: 220,
                    isResizable: true,
                  }
                ]}
                // columns={
                //   tokenData.isAdmin && [0, 2].includes(tokenData.role) ? [
                //     {
                //       key: "checkbox",
                //       name: "",
                //       fieldName: "checkbox",
                //       minWidth: 50,
                //       maxWidth: 50,
                //       isResizable: false,
                //     },
                //     {
                //       key: "customerId",
                //       name: "Customer",
                //       fieldName: "customerId",
                //       minWidth: 250,
                //       maxWidth: 370,
                //       isResizable: true,
                //     },
                //     {
                //       key: "legendId",
                //       name: "Legend Id",
                //       fieldName: "legendId",
                //       minWidth: 120,
                //       maxWidth: 150,
                //       isResizable: true,
                //     },
                //     {
                //       key: "discussion",
                //       name: "Discussion / Action Items",
                //       // name: "Discussion",
                //       fieldName: "discussion",
                //       minWidth: 200,
                //       maxWidth: 400,
                //       isResizable: true,
                //     },
                //     {
                //       key: "owner",
                //       name: "Owner",
                //       fieldName: "owner",
                //       minWidth: 150,
                //       maxWidth: 250,
                //       isResizable: true,
                //     },
                //     {
                //       key: "sttParticipantName",
                //       name: "STTGDC Participant's Name",
                //       fieldName: "sttParticipantName",
                //       minWidth: 200,
                //       maxWidth: 250,
                //       isResizable: true,
                //     },
                //     {
                //       key: "customerParticipantName",
                //       name: "Customer Participant's Name",
                //       fieldName: "customerParticipantName",
                //       minWidth: 250,
                //       maxWidth: 300,
                //       isResizable: true,
                //     },
                //     {
                //       key: "customerParticipantEmail",
                //       name: "Customer Participant's Email",
                //       fieldName: "customerParticipantEmail",
                //       minWidth: 250,
                //       maxWidth: 300,
                //       isResizable: true,
                //     },
                //     {
                //       key: "meetingDate",
                //       name: "Meeting Date",
                //       fieldName: "meetingDate",
                //       minWidth: 170,
                //       maxWidth: 220,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "meetingDate",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "targetDate",
                //       name: "Reporting Date",
                //       fieldName: "targetDate",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "targetDate",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "completionDate",
                //       name: "Completion Date",
                //       fieldName: "completionDate",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "completionDate",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "status",
                //       name: "Status",
                //       fieldName: "status",
                //       minWidth: 130,
                //       maxWidth: 200,
                //       isResizable: true,
                //     },
                //     {
                //       key: "meetingLocation",
                //       name: "Meeting Location",
                //       fieldName: "meetingLocation",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //     },
                //     {
                //       key: "remarks",
                //       name: "Latest Updates",
                //       // name: "Remarks",
                //       fieldName: "remarks",
                //       minWidth: 200,
                //       maxWidth: 300,
                //       isResizable: true,
                //     },
                //     {
                //       key: "aging",
                //       name: "Aging (in Days)",
                //       fieldName: "aging",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "aging",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "userId",
                //       name: "Added By",
                //       fieldName: "userId",
                //       minWidth: 170,
                //       maxWidth: 220,
                //       isResizable: true,
                //     },
                //     {
                //       key: "showInPpt",
                //       name: "Show In PPT",
                //       fieldName: "showInPpt",
                //       minWidth: 130,
                //       maxWidth: 180,
                //       isResizable: true,
                //     },
                //     {
                //       key: "actions",
                //       name: "Actions",
                //       fieldName: "actions",
                //       minWidth: 80,
                //       maxWidth: 110,
                //       isResizable: true,
                //     },
                //   ] : [
                //     {
                //       key: "customerId",
                //       name: "Customer",
                //       fieldName: "customerId",
                //       minWidth: 170,
                //       maxWidth: 370,
                //       isResizable: true,
                //     },
                //     {
                //       key: "legendId",
                //       name: "Legend Id",
                //       fieldName: "legendId",
                //       minWidth: 120,
                //       maxWidth: 150,
                //       isResizable: true,
                //     },
                //     {
                //       key: "discussion",
                //       name: "Discussion / Action Items",
                //       // name: "Discussion",
                //       fieldName: "discussion",
                //       minWidth: 200,
                //       maxWidth: 400,
                //       isResizable: true,
                //     },
                //     {
                //       key: "owner",
                //       name: "Owner",
                //       fieldName: "owner",
                //       minWidth: 150,
                //       maxWidth: 250,
                //       isResizable: true,
                //     },
                //     {
                //       key: "sttParticipantName",
                //       name: "STTGDC Participant's Name",
                //       fieldName: "sttParticipantName",
                //       minWidth: 200,
                //       maxWidth: 250,
                //       isResizable: true,
                //     },
                //     {
                //       key: "customerParticipantName",
                //       name: "Customer Participant's Name",
                //       fieldName: "customerParticipantName",
                //       minWidth: 250,
                //       maxWidth: 300,
                //       isResizable: true,
                //     },
                //     {
                //       key: "customerParticipantEmail",
                //       name: "Customer Participant's Email",
                //       fieldName: "customerParticipantEmail",
                //       minWidth: 250,
                //       maxWidth: 300,
                //       isResizable: true,
                //     },
                //     {
                //       key: "meetingDate",
                //       name: "Meeting Date",
                //       fieldName: "meetingDate",
                //       minWidth: 170,
                //       maxWidth: 220,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "meetingDate",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "targetDate",
                //       name: "Reporting Date",
                //       fieldName: "targetDate",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "targetDate",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick,
                //     },
                //     {
                //       key: "completionDate",
                //       name: "Completion Date",
                //       fieldName: "completionDate",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "completionDate",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "status",
                //       name: "Status",
                //       fieldName: "status",
                //       minWidth: 130,
                //       maxWidth: 200,
                //       isResizable: true,
                //     },
                //     {
                //       key: "meetingLocation",
                //       name: "Meeting Location",
                //       fieldName: "meetingLocation",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //     },
                //     {
                //       key: "remarks",
                //       name: "Latest Updates",
                //       // name: "Remarks",
                //       fieldName: "remarks",
                //       minWidth: 150,
                //       maxWidth: 250,
                //       isResizable: true,
                //     },
                //     {
                //       key: "aging",
                //       name: "Aging (in Days)",
                //       fieldName: "aging",
                //       minWidth: 150,
                //       maxWidth: 200,
                //       isResizable: true,
                //       isSorted: state.searchObj.sortBy === "aging",
                //       isSortedDescending: state.searchObj.sortOrder === "desc",
                //       onColumnClick: onColumnClick
                //     },
                //     {
                //       key: "userId",
                //       name: "Added By",
                //       fieldName: "userId",
                //       minWidth: 170,
                //       maxWidth: 220,
                //       isResizable: true,
                //     },
                //     {
                //       key: "showInPpt",
                //       name: "Show In PPT",
                //       fieldName: "showInPpt",
                //       minWidth: 130,
                //       maxWidth: 180,
                //       isResizable: true,
                //     },
                //   ]}
                compact={true}
                setKey="set"
                onRenderItemColumn={_renderItemColumn as any}
                layoutMode={DetailsListLayoutMode.justified}
                // selectionMode={[0, 2].includes(tokenData.role) ? SelectionMode.multiple : SelectionMode.none}
                selectionMode={SelectionMode.none}
                onRenderRow={_onRenderRow}
              // onRenderDetailsHeader={_onRenderDetailsHeader}
              // selection={_selection}
              // selectionPreservedOnEmptyClick={true}
              />
            </Fabric>
            // </MarqueeSelection>
          ) : (
            <NoDataTile title="No Customer Meetings Found"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
      {/* {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  handleDialogOpen(true, state.manageActionsCallout.index);
                }}
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() => {
                  deletePm(
                    state.manageActionsCallout.data as IPreviousMeeting,
                    state.manageActionsCallout.index as number
                  );
                }}
                className="callout-options"
              >
                Delete
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )} */}
      {/* {state.manageAcDialog.isOpen && (
        <ManagePmDialog
          data={state.manageAcDialog.data}
          handleLoading={handleLoading}
          handleDialogClose={(data: IPreviousMeeting) =>
            handleDialogClose(data)
          }
          customerId={params.customerId}
          userList={state.userListByCustomerId[state.manageAcDialog.data?.customerId as string] || []}
          isFromDashboard={true}
          customerName={state.manageAcDialog.customerName}
        />
      )} */}
      {/* {isSendEmailDialogOpen && (
        <ManagePmSendEmailDialog
          meetingIds={selectedMeetingIds}
          handleClose={(isSendEmail?: boolean) =>
            handleEmailDialogOpenClose(false, isSendEmail)
          }
          meetingList={[]}
        />
      )} */}
    </React.Fragment>
  );
};

export default MomStatusDetails;
